import {BriefWhereInfo} from "../utils.jsx";
import {getWhenSectionTitleForBrief} from "../../event/OrderInformationCard/utils";

export const generateSquareBriefInfoProvider = briefInfo => {
    if (!briefInfo) {
        return [];
    }

    return [
        {
            row: [
                {
                    title: "🏢 איפה?",
                    component: <BriefWhereInfo briefInfo={briefInfo} />
                },
                {
                    title: "📅 מתי?",
                    component: (
                        <div>
                            {getWhenSectionTitleForBrief({
                                ...briefInfo,
                                until: briefInfo?.dtstart,
                                dtstart: briefInfo?.dtstart - 2 * 60 * 60 * 1000
                            })}
                        </div>
                    ),
                    shouldShow: true
                },
                {
                    title: "🙎 מספר משתתפים",
                    component: <div>{briefInfo?.participantsAmount}</div>,
                    shouldShow: true
                },
                {
                    title: "🙎‍  תקציב להזמנה (כולל מע״מ)",
                    component: <b style={{fontSize: 30}}>₪ {briefInfo?.maxPrice}</b>,
                    shouldShow: true
                }
            ]
        }
    ];
};

export const generateBriefRowsInfoProvider = briefInfo => {
    if (!briefInfo) {
        return [];
    }

    return [
        {
            title: "📃 פרטים נוספים",
            component: <div>{briefInfo?.description}</div>,
            shouldShow: true
        }
    ];
};

export const initialItem = {
    key: Date.now() + Math.random(),
    name: "",
    sku: "",
    price: undefined,
    amount: undefined,
    foodRequests: []
};

export const initialFormValues = {
    package: {
        options: [initialItem],
        files: [],
        photos: []
    },
    dtstart: 0
};
